<template>
  <div>
    <header-bar>
      スプリット
    </header-bar>
    <div class="page-block">
      <revenue-share-sub-header :sub-header="subHeader" />
      <split-information-link />
      <div v-if="initialTotalRelease>0">
        <div class="page-block__inner">
          <release-step-area :is-revenue-page="true">
          </release-step-area>
          <revenue-share-search
            style="margin-bottom:14px"
            @setKeyWord="onClickedSearch" />
          <revenue-share-detail-table
            :headers="actionableTableHeader"
            :data="releaseList.data"
            page-name="revenueShare"
            @redirectToPage="redirectToPage" />
        </div>
        <pagination
          :pagination="releaseList"
          @on-pagination-clicked="onPaginationClicked($event)">
        </pagination>
      </div>
      <div
        v-else
        class="no-data-display">
        <p class="no-data-display__title">
          登録されているリリースがありません。
        </p>
        <p class="no-data-display__desc">配信中のリリースのみスプリット設定が可能です。</p>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'
import ReleaseStepArea from '../Release/StepArea'
import Pagination from '../../../components/Pagination'
import SplitInformationLink from './SplitInformationLink'
import RevenueShareSearch from './RevenueShareSearch'
import RevenueShareSubHeader from './RevenueShareSubHeader'
import RevenueShareDetailTable from './RevenueShareDetailTable'

export default {
  name: 'RevenueAndShare',
  components: {
    ReleaseStepArea,
    HeaderBar,
    Pagination,
    SplitInformationLink,
    RevenueShareSearch,
    RevenueShareSubHeader,
    RevenueShareDetailTable,
  },
  data() {
    return {
      expanded: [],
      preKeyword: '',
      keyword: '',
      loading: false,
      revenueShareId: null,
      releaseList: {
        current_page: 0,
        last_page: 2,
        per_page: 10,
        total: 0,
        data: [],
      },
      tableHeader: [
        {
          name: 'ジャケット',
          class: 'img-header',
        },
        { name: 'リリース種別' },
        { name: 'アーティスト名' },
        { name: '作品タイトル' },
        { name: '' },
      ],
      actionableTableHeader: [{
        name: 'ジャケット',
        class: 'img-header',
        style: '',
        key: 'coverart_filepath',
        imgStyle: 'width: 50px; height: 50px',
      },
      {
        name: '作品タイトル',
        class: '',
        style: 'width: 12%',
        actionable: true,
        key: 'title',
      },
      {
        name: 'アーティスト名',
        key: 'artist_name',
      },
      {
        name: 'リリース種別',
        key: 'type',
        actionable: true,
      },
      {
        name: '',
        class: '',
        key: '',
        buttonText: ['スプリット設定'],
        buttonClass: 'c-btn',
        buttonStyle: 'min-width: 10px',
        button: true,
      }],
      emptyTableMessage: 'スプリット可能なリリースはありません。',
      initialTotalRelease: 0,
      subHeader: 'リリース選択',
      typeAlbum: 'album',
    }
  },
  watch: {
    keyword() {
      this.getProduct()
    },
  },
  mounted() {
    this.getProduct()
  },
  methods: {
    async getProduct(page = 0, count = 10) {
      this.loading = true
      const escStr = escape(this.keyword)
      const { data } = await window.axios.get(`/api/client/revenueShare/product/discTrack?page=${page}&count=${count}&keyword=${this.keyword}&uniKeyword=${escStr}`)
      const selectedItems = []
      // Loop through each key of grouped data with productId as key
      Object.keys(data.data).forEach(key => {
        const array = data.data[key]
        // Check if the array is not empty and select the first revenue share
        if (Array.isArray(array) && array.length > 0) {
          const metaArtists = JSON.parse(array[0].meta_artists)
          array[0].artist_name = metaArtists.main_artists.map(artist => artist.name_ja).join(', ')
          selectedItems.push(array[0])
        }
      })

      this.releaseList = data
      this.releaseList.data = selectedItems
      this.loading = false

      if (!this.keyword) {
        this.initialTotalRelease = this.releaseList.total
      }
    },
    onPaginationClicked(page) {
      this.getProduct(page)
    },
    onClickedSearch(event) {
      this.preKeyword = event
      this.keyword = event
    },
    redirectToPage(path) {
      this.$router.push({ path })
    },
  },
}
</script>

<style scoped>
.table-search-top input {
  width: 360px;
}
.my-release-list__thead th {
  padding: 10px 0 10px 0;
}

.flex_end{
  display:flex;
  justify-content: flex-end;
  margin-right: 4px;
  margin-left: 4px;
}

.img-header {
  width: 12em;
}

.no-data-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 8rem;
}

.no-data-display__title {
  font-weight: bold;
  font-size: 27px;
}

.no-data-display__desc {
  margin: 2rem 0;
}
</style>
